import EmailIcon from '@mui/icons-material/Email';
import {
  Button,
  ButtonGroup,
  Stack,
} from '@mui/material';
import { Dispatch, FC, SetStateAction, useRef, useState } from 'react';

import { useSendMessage } from '@features/messaging/hooks/useSendMessage';
import { useUnreadMessages } from '@features/messaging/hooks/useUnreadMessages';

type RockerboxSendMessageButtonsProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
  message: string;
  threadId?: number;
  companyId?: number;
  recipientId: number | undefined;
  onSendSuccess: () => void;
  file: File | null;
  onUnreadSuccess: () => void;
};

const RockerboxSendMessageButtons: FC<RockerboxSendMessageButtonsProps> = ({
  setErrorText,
  message,
  recipientId,
  threadId,
  companyId,
  onSendSuccess,
  file,
  onUnreadSuccess,
}) => {
  const [isSendMenuOpen, setIsSendMenuOpen] = useState(false);
  const [isScheduleMessageModalOpen, setIsScheduleMessageModalOpen] =
    useState(false);
  const sendButtonRef = useRef<HTMLDivElement>(null);
  const { sendMessage, isSendingMessage } = useSendMessage({
    setErrorText,
  });

  const handleSend = async (message: string) => {
    const payload = {
      company_id: companyId,
      message,
      file,
      ...(threadId ? { thread_id: threadId } : {}),
    };

    sendMessage(payload, {
      onSuccess: () => onSendSuccess(),
    });

    // setProgress(100);
  };

  const { unreadMessages } = useUnreadMessages({ setErrorText });

  return (
    <Stack spacing={2} direction="row">
      <ButtonGroup
        variant="contained"
        color="secondary"
        ref={sendButtonRef}
        disabled={!message || isSendingMessage}
        sx={{ flexGrow: 1, borderRadius: '6px' }}
      >
        <Button
          sx={{ borderRadius: '6px', fontSize: '14px' }}
          fullWidth
          onClick={() =>
            handleSend(message)
          }
        >
          Send Message
        </Button>
      </ButtonGroup>
      {/* <Popper
        open={isSendMenuOpen}
        anchorEl={sendButtonRef.current}
        disablePortal
        placement="top-end"
      >
        <Paper>
          <ClickAwayListener onClickAway={() => setIsSendMenuOpen(false)}>
            <MenuList>
              <MenuItem onClick={() => setIsScheduleMessageModalOpen(true)}>
                Schedule Message
              </MenuItem>
            </MenuList>
          </ClickAwayListener>
        </Paper>
      </Popper>
      <ScheduleMessageModal
        isOpen={isScheduleMessageModalOpen}
        handleClose={() => setIsScheduleMessageModalOpen(false)}
      /> */}
    </Stack>
  );
};

export default RockerboxSendMessageButtons;
